<div class="checkbox mb-1 w-full h-auto">
    <div class="relative w-full" id="myWidget" data-size="normal"></div>
    <!-- <div *ngIf="show_skeleton" class="relative w-309px h-16 animate-pulse bg-gray-300"></div> -->
</div>
